import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { LoadingScreenService } from 'src/app/shared-services/loading-screen.service';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService } from 'src/app/analytics/google.analytics.service';
declare var $: any;

@Component({
    selector: 'app-finicity-link',
    templateUrl: './finicity-link.component.html',
    styleUrls: ['./finicity-link.component.css']
})
export class FinicityLinkComponent implements OnInit, OnDestroy {
    public token: any;

    public applicationId: number;
    public errorGettingOffers: boolean;
    public vodRequired: boolean;
    public finicityCompletedError: boolean;
    public loaded: boolean;
    public recalculateFormControl: FormControl = new FormControl();
    public errorTitle = '';
    public errorMessageA = '';
    public errorId = 'OffersE';

    public statesOfIncorporation: any[] = [];
    public industries: any[] = [];

    private offers: any = {
        offerList: []
    };

    private tryCount: number = 0;

    constructor(
        private route: ActivatedRoute,
        private connectionService: ConnectionService,
        public router: Router,
        private authService: AuthService,
        private formBuilder: FormBuilder,
        private loadingScreenService: LoadingScreenService,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.googleAnalyticsService.trackEvent('application', 'Finicity', 'application-token');
    }

    ngOnInit() {
        if (this.route.snapshot.queryParams.token) {
            this.token = this.route.snapshot.queryParams.token;
        } else {
            this.router.navigateByUrl('/');
        }

        this.loaded = false;
        this.finicityLinkValidate().then(
            (data: any) => {
                this.getOffers(this.applicationId).then(
                    (data: any) => {
                        if (data.object && data.object.vodRequired) {
                            this.vodRequired = true;
                            this.getFinicityURL(this.applicationId).then(
                                () => { this.loaded = true; },
                                () => { this.loaded = true; }
                            )
                        } else {
                            this.vodRequired = false;
                            this.loaded = true;
                        }
                    },
                    (error: any) => {
                        this.loaded = true;
                    }
                );
            }, (error: any) => {
                this.loaded = true;
                this.router.navigateByUrl('/');
            }
        );
    }

    ngOnDestroy() {
        window['finicityConnect'].destroy();
    }

    finicityLinkValidate() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequestWithToken(environment.gateway + 'application/finicity-link/validate', 'application/json', this.token).subscribe(
                (data: any) => {
                    this.applicationId = data.object;
                    resolve(data);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
    }

    getOffers(applicationId: number, options?: any) {
        return new Promise((resolve, reject) => {
            const url = environment.gateway + 'application/' + applicationId + '/activeOffersNl';
            this.connectionService.getRequestWithToken(url, 'application/json', this.token).subscribe(
                (data: any) => {
                    if (data.object) {
                        if (data.object.status != 'REJECTED') {
                            this.offers = data.object;
                            this.errorGettingOffers = false;
                        } else {
                            this.errorGettingOffers = true;
                        }
                    } else {
                        this.errorGettingOffers = true;
                    }
                    resolve(data);
                },
                (error: any) => {
                    this.errorGettingOffers = true;
                    reject(error);
                }
            );
        });
    }

    validateTransaction(applicationId: number) {
        this.tryCount += 1;
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                this.connectionService.getRequestUnsecured(environment.gateway + 'application/transaction/validate/' + applicationId, 'application/json').subscribe(
                    (data: any) => {
                        if (data.object) {
                            resolve(data);
                        } else if (this.tryCount < 3) {
                            this.validateTransaction(this.applicationId).then(
                                (vData: any) => resolve(vData),
                                (vError: any) => reject(vError)
                            );
                        } else {
                            reject(data);
                        }
                    }, (error: any) => {
                        reject(error);
                    }
                );
            }, 20000);
        });
    }

    getFinicityURL(applicationId: number) {
        return new Promise((resolve, reject) => {
            this.connectionService.getCustomRequest(`${environment.gateway}applicationNl/${applicationId}/vod/information`, 'application/json', undefined, 'token', this.token).subscribe(
                (data: any) => {
                    if (data.object) {
                        if (data.object.url) {
                            window['finicityConnect'].launch(data.object.url, {
                                selector: '#finicityIframe',
                                overlay: 'rgba(255,255,255, 0)',
                                success: (event) => {
                                    if (event.reason == 'complete' && event.code == 200) {
                                        this.loaded = false;
                                        this.tryCount = 0;
                                        this.loadingScreenService.startFinicityLoading();
                                        this.validateTransaction(this.applicationId).then(
                                            (vData: any) => {
                                                this.getOffers(this.applicationId, { finicity: true }).then(
                                                    (data: any) => {
                                                        this.loadingScreenService.stopFinicityLoading();
                                                        this.finicityCompletedError = false;
                                                        this.vodRequired = false;
                                                        this.loaded = true;
                                                    },
                                                    (error: any) => {
                                                        this.loadingScreenService.stopFinicityLoading();
                                                        this.finicityCompletedError = true;
                                                        this.loaded = true;
                                                    }
                                                )
                                            },
                                            (vError: any) => {
                                                this.loadingScreenService.stopFinicityLoading();
                                                this.finicityCompletedError = true;
                                                this.loaded = true;
                                            }
                                        );
                                    }
                                },
                                cancel: (event) => { },
                                error: (error) => { },
                                loaded: () => {
                                    $('div.finicityIframe')[0].appendChild($('#finicityConnectIframe')[0]);
                                },
                                route: (event) => { },
                                user: (event) => { }
                            });
                        } else {
                            this.router.navigateByUrl('/general-error');
                        }
                    }
                    resolve(data);
                },
                (error: any) => {
                    this.errorGettingOffers = true;
                    this.router.navigateByUrl('/general-error');
                    reject(error);
                }
            );
        });
    }

    onContinueClick() {
        this.router.navigateByUrl('/home', { state: { appId: this.applicationId } });
    }

    sendFinicityVerifyBankAccountEmail() {
        return new Promise((resolve, reject) => {
            this.connectionService.getRequestWithToken(environment.gateway + 'application/finicity-link/' + this.applicationId, 'application/json', this.token).subscribe(
                (data: any) => {
                    this.errorTitle = 'Email sent.';
                    this.errorMessageA = 'An email to verify your bank account was sent.';
                    $('#errorModalDialogOffersE').modal();
                    resolve(data);
                },
                (error: any) => {
                    this.errorTitle = 'Error sending email.';
                    this.errorMessageA = error.error.msg;
                    $('#errorModalDialogOffersE').modal();
                    reject(error);
                }
            );
        });
    }

    get displayOption(): string {
        if (this.finicityCompletedError) {
            return 'finicityError';
        } else if (this.vodRequired) {
            return 'finicity';
        } else if (this.errorGettingOffers) {
            return 'offersError';
        } else {
            return 'offers';
        }
    }

}
